import { createSlice } from '@reduxjs/toolkit'

interface LanguageState {
    activeLanguage: string
}

const initialState: any = {
    activeLanguage: localStorage.getItem('activeLanguage') || 'tr'
}

export const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setActiveLanguage: (state: LanguageState, action) => {
            state.activeLanguage = action.payload;
        }
    }
})

export const { setActiveLanguage } = languageSlice.actions;

export default languageSlice.reducer;